import { css } from "@emotion/react";
import { Skeleton } from "@mui/material";
import { ICONS } from "@/modules/ui-elements/Icon";

const DropSelectSkeleton = () => {
  
  return (
    <div css={styles.dropSelectContainer}>
      <div css={styles.title}>
        <Skeleton width={150} variant="rectangular" />
      </div>
      
      <div css={styles.imageBtnContainer}>
        <div css={styles.imageContainer}>
          <Skeleton width={40} variant="rectangular" />
        </div>
        <div css={styles.viewAllBtn}>
          <Skeleton width={80} variant="rectangular" />
        </div>
      </div>
      
      <div css={styles.submitBtn}>
        <span>Create</span>
        <img src={ICONS.rightArrowVector} alt="" height={11} />
      </div>

    </div>
  )
};

export default DropSelectSkeleton;

const styles = {
  dropSelectContainer: css`
    width: 456px;
    border-radius: 8px;
    border: 1px solid #DEDEDE;
    padding: 20px 18px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    position: relative;
  `,
  title: css`
    font-size: 14px;
    font-weight: 400;
    line-height: 23.8px;
    letter-spacing: 0.01em;
  `,
  imageBtnContainer: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  imageContainer: css`
    width: 64px;
    height: 48px;
    border-radius: 4px;
    border: 0.5px solid #DDE8FE;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  image: css`
    width: 32px;
    object-fit: contain;
  `,
  viewAllBtn: css`
    border-radius: 4px;
    border: 1px solid #DEDEDE;
    padding: 10px 8px;
    cursor: default;
    font-size: 12px;
    letter-spacing: -0.1px;
    font-weight: 500;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
  `,
  submitBtn: css`
    width: 424px;
    height: 48px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    background: #F9F9F9;
    border: none;
    font-size: 14.3px;
    font-weight: 400;
    cursor: default;
    transition: all 0.3s;
    opacity: 0.3;
  `
}